import { render } from "./SideBar.molecule.vue?vue&type=template&id=9f7ea60e&scoped=true&bindings={\"isSidebarOpen\":\"props\",\"emit\":\"setup\"}"
import script from "./SideBar.molecule.vue?vue&type=script&lang=js"
export * from "./SideBar.molecule.vue?vue&type=script&lang=js"

import "./SideBar.molecule.vue?vue&type=style&index=0&id=9f7ea60e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9f7ea60e"

export default script